export function isVisibleOnNavBar(link, userRole) {
  if (!link) return false;
  const granted = (userRole?.links ?? []).some(
    (entry) => entry.link === link.linkId && Number(entry.accessRight ?? 0) > 0
  );
  if (!granted) return false;
  if (link.showOnNavBar === true) return true;
  return (userRole?.sidebarLinks ?? []).some(
    (entry) => entry.link === link.linkId
  );
}
